import React, { useState, useEffect } from 'react';
import { Box, Card, Typography, Breadcrumbs, Divider, Button } from '@mui/material';
import { Link, useNavigate, useParams } from 'react-router-dom';
import { Formik, Form } from 'formik';
import { useDispatch, useSelector } from 'react-redux';
import { useResponseHandler } from 'hooks/useResponseHandler';
import formInitialValues from './formik/formInitialValues';
import validationSchema from './formik/validationSchema';
import suscripcionesFormModel from './formik/suscripcionesFormModel';
import { SuscripcionesForm } from './components/forms/SuscripcionesForm';
import { editServicesIaCustomerSuscriptionStore, getServicesIaCustomerSuscriptionByIdStore } from 'store/services-ia-customer-suscriptions/thunks';
import { MessagesDrawerRight } from 'components/MessagesDrawerRight';
import { servicesIaCustomerSuscriptionsMapper } from './mappers/suscripciones.mapper';
import { getFormsSuscriptionsStore } from 'store/services-ia-customer-suscriptions/thunks';

export const EditSuscripciones = () => {
    const { id } = useParams<{ id: string }>();
    const dispatch: any = useDispatch();
    const navigate = useNavigate();
    const { handleResponse, ResponseComponents } = useResponseHandler();
    const { formId, formField } = suscripcionesFormModel;
    
    const { suscription, customer_for_select } = useSelector((state: any) => state.servicesIaSuscriptions);
    const [dataErrors, setMsgErrors] = useState([]);
    const [initialValues, setInitialValues] = useState<any>(formInitialValues);

    useEffect(() => {
        if (id) {
            dispatch(getServicesIaCustomerSuscriptionByIdStore(id));
        }
    }, [id, dispatch]);

    useEffect(() => {
        if (suscription && Object.keys(suscription).length > 0) {
            const isPlanIdObject = typeof suscription.planId === 'object' && suscription.planId !== null;
            const mappedPlanId = isPlanIdObject ? suscription.planId : (suscription.plan ? {
                value: suscription.plan.id,
                label: suscription.plan.name,
                price: suscription.plan.monthlyPrice,
                currency: suscription.plan.currency,
                monthlyCredits: suscription.plan.monthlyCredits,
                duration: suscription.plan.durationDays
            } : '');

            const finalCustomer = suscription.customer || { 
                label: suscription.customerId, 
                value: suscription.customerId,
                name: suscription.customerId
            };

            setInitialValues({
                customerId: finalCustomer,
                planId: mappedPlanId,
                startsAt: suscription.startsAt ? suscription.startsAt.split('T')[0] : null,
                expiresAt: suscription.expiresAt ? suscription.expiresAt.split('T')[0] : null,
                renewalType: suscription.renewalType || '',
                monthlyCredits: suscription.monthlyCredits !== null ? suscription.monthlyCredits : '',
                nextRenewalAt: suscription.nextRenewalAt ? suscription.nextRenewalAt.split('T')[0] : null,
                statusSuscription: suscription.statusSuscription || '',
            });
        }
    }, [suscription, customer_for_select]);

    const onSubmit = async (values: any, actions: any) => {
        const payload = servicesIaCustomerSuscriptionsMapper.toEditDto(values);
        const response = await dispatch(editServicesIaCustomerSuscriptionStore(id as string, payload));
        
        await handleResponse(response, 'Suscripción Actualizada', true);
        actions.setSubmitting(false);

    };

    

    return (
        <Box sx={{ width: '100%', mb: 5 }}>
            {ResponseComponents}
            <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', mb: 3 }}>
                <Box>
                    <Typography variant="h5" sx={{ fontWeight: 700, mb: 1, color: 'text.primary' }}>
                        Editar Suscripción
                    </Typography>
                    <Breadcrumbs aria-label="breadcrumb">
                        <Link color="inherit" to="/manager/plataforma-ia/comercial/suscripciones">
                            Suscripciones
                        </Link>
                        <Typography color="text.primary">Editar Suscripción</Typography>
                    </Breadcrumbs>
                </Box>
            </Box>

            <Card sx={{ p: 4, borderRadius: 3, boxShadow: '0px 4px 20px rgba(0, 0, 0, 0.05)' }}>
                <Formik
                    initialValues={initialValues}
                    validationSchema={validationSchema}
                    onSubmit={onSubmit}
                    enableReinitialize
                >
                    {(props) => (
                        <Form id={formId}>
                            <SuscripcionesForm formField={formField} isEditing={true} />

                            <Divider sx={{ my: 4 }} />

                            <Box sx={{ display: 'flex', justifyContent: 'flex-end', gap: 2 }}>
                                <Button
                                    component={Link}
                                    to="/manager/plataforma-ia/comercial/suscripciones"
                                    variant="outlined"
                                    color="inherit"
                                    sx={{ borderRadius: 2, px: 3 }}
                                >
                                    Cancelar
                                </Button>
                                <Button
                                    type="submit"
                                    variant="contained"
                                    color="primary"
                                    disabled={props.isSubmitting || !props.dirty}
                                    sx={{ borderRadius: 2, px: 4, boxShadow: '0px 4px 10px rgba(105, 108, 255, 0.3)' }}
                                >
                                    {props.isSubmitting ? 'Guardando...' : 'Guardar Cambios'}
                                </Button>
                            </Box>
                        </Form>
                    )}
                </Formik>
            </Card>

            <MessagesDrawerRight
                data={dataErrors}
                open={dataErrors.length > 0}
                setMsg={setMsgErrors}
            />
        </Box>
    );
};
